import React, { memo, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { sessionCache, KEYS } from '@services/cache';
import Tooltip from '../Tooltip';
import {
  ContainerToggle,
  ButtonSwitcher,
  Container,
  ButtonToggle,
  Switcher,
  PickupCoachMark,
} from './components';
import messages from './messages';

const SHOP_LIST = 'shop_list';
const MAX_COUNT_COACH_MARK = 4;

const Toggle = ({ isPickup, origin, onClick, intl: { formatMessage } }) => {
  const [coachMarkEnabled, setCoachMarkEnabled] = useState(false);
  const isFromShopList = useMemo(() => origin === SHOP_LIST, [origin]);
  const showCoachMark = useMemo(() => !isFromShopList && isPickup, [
    isFromShopList,
    isPickup,
  ]);
  const onClose = () => {
    setCoachMarkEnabled(false);
  };

  useEffect(() => {
    const counter = sessionCache.get(KEYS.PICKUP_COACH_MARK) || 0;
    if (showCoachMark && counter < MAX_COUNT_COACH_MARK) {
      sessionCache.set(KEYS.PICKUP_COACH_MARK, counter + 1);
      setCoachMarkEnabled(true);
    } else {
      setCoachMarkEnabled(false);
    }
  }, [isPickup, showCoachMark]);

  return (
    <Container>
      <ContainerToggle>
        <ButtonToggle active={!isPickup} onClick={() => onClick(false)}>
          {formatMessage(messages.delivery)}
        </ButtonToggle>
        <ButtonToggle active={isPickup} onClick={() => onClick(true)} relative>
          {formatMessage(messages.pickup)}
        </ButtonToggle>
        <PickupCoachMark isOpen={coachMarkEnabled} onClose={onClose} />
        {!showCoachMark && <Tooltip isPickup={isPickup} />}
        <Switcher active={isPickup}>
          <ButtonSwitcher />
        </Switcher>
      </ContainerToggle>
    </Container>
  );
};

Toggle.propTypes = {
  isPickup: PropTypes.bool,
  origin: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(memo(Toggle));
